import React from 'react';
import styles from './Guide.module.css';

const DetailLevelSelector = ({ onSelect }) => {
  return (
    <div className={styles['detail-level-selector']}>
      <h2>Choisis ton niveau de précision</h2>
      <div className={styles['level-buttons']}>
        <button onClick={() => onSelect('normal')}>
          🟢 Normal<br />
          <small>Version simple, questions essentielles</small>
        </button>
        <button onClick={() => onSelect('avance')}>
          🟠 Avancé<br />
          <small>Plus de détails, précision par sous-partie</small>
        </button>
        <button onClick={() => onSelect('expert')}>
          🔴 Expert<br />
          <small>Avec jalons, responsabilités, échéancier</small>
        </button>
      </div>
    </div>
  );
};

export default DetailLevelSelector;
